import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { primaryButtonBase } from "../styles/buttonStyles";
import { useCalPopup } from "../utils/useCalPopup";
import { accentColorPairs } from "../styles/designSystem";

// The terminal only has a handful of phosphor hues; picking from a wider set would
// break the CRT illusion, so this pulls from the design system's accent shortlist.
const getRandomColor = () =>
    accentColorPairs[Math.floor(Math.random() * accentColorPairs.length)].bg;

const Button = styled.button`
    ${primaryButtonBase}
    padding: ${({ size }) => (size === 'small' ? '0.5rem 1rem' : '0.85rem 1.5rem')};
    font-size: ${({ size }) => (size === 'small' ? '0.72rem' : '0.85rem')};

    svg {
        font-size: ${({ size }) => (size === 'small' ? '0.8rem' : '0.95rem')};
    }
`;

const ContactButton = ({ children = "Book a Call", size, color, event = "30min" }) => {
    const [randomColor] = useState(getRandomColor);
    const buttonColor = color || randomColor;
    const calProps = useCalPopup(event);

    return (
        <Button {...calProps} color={buttonColor} size={size}>
            <FontAwesomeIcon icon={faCalendarDays} />
            {children}
        </Button>
    );
};

export default ContactButton;
